import $ from "jquery";
import { createGuid, contentMeta, getDynData, truncateWithElipsis } from "#scripts/general_functions";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import language from "#scripts/translation";
import cardslist, { carditem } from "#templates/modules/cardlisting_template";
import { AimError } from "#scripts/tools/aimlog.js";
import { getLangForApi } from "#scripts/cmsapi.js";

export const getItems = async (category, load, from, callback) => {
  const senddata = {
    categoryId: category,
    subscriptionId: window.serverdata.configMeta.aim.clientId,
  };

  const apiCall = `${window.apiUrl}/Public/articles`;
  const apiParameters = `?subscriptionId=${window.serverdata.configMeta.aim.clientId
    }&category=${category}&language=${getLangForApi()}&limit=${load}&offset=${from}&includeCategories=true&getRecursiveContent=true&LanguageMode=Strict`;

  try {
    const response = await fetch(apiCall + apiParameters, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    callback(data);
  } catch (error) {
    AimError(`API Error: ${error.toString()}`, `${window.apiUrl}/Public/articles`);
  }
};

export const getSingleItem = async (contentId, callback) => {
  const apiCall = `${window.apiUrl}/Public/articles/${contentId}?subscriptionId=${window.serverdata.configMeta.aim.clientId}`;
  const apiParameters = `?subscriptionId=${window.serverdata.configMeta.aim.clientId}`;

  try {
    const response = await fetch(apiCall + apiParameters, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    callback(data);
  } catch (error) {
    AimError(`API Error: ${error.responseText.toString()}`, `${window.apiUrl}/Public/articles`);
  }
};

export const getCategoryFromString = async (category) => {
  const response = await fetch(`${window.apiUrl}/CategoryApi/getbytitle/${category}`);
  const json = await response.json();

  if (json.length > 0) {
    for (const cat of json) {
      if (cat.subscriptionId === window.serverdata.configMeta.aim.clientId) {
        return cat.categoryId;
      }
    }
  }
};

export const cardsFront = (
  category,
  maxItems,
  moduleTitle,
  moreText = "Se mer",
  moreLink = "",
  cardDesign = "",
  showCategories = true,
  sortOrder = "sortByDate",
  moduleCardColor = "",
) => {
  const categoryId = category;
  const moduleGuid = createGuid();
  let sortAsc = 1;

  if (category === undefined || category === "") {
    return "";
  }

  const idList = category.split(",");
  if (idList.length > 1) {
    // Handle multiple categories if needed
  } else {
    getItems(category, maxItems, 0, (_data) => {
      const cards = [];
      const data = _data.listOfContent;

      if (data?.length > 0) {
        for (const card of data) {
          const meta = contentMeta(card);
          const cardGuid = createGuid();

          const isTransportPage = card.contentTypeGuid === "1bb71f41-4ee6-4394-b78f-3202e2f5eeda";
          const shouldShow = isTransportPage ? showCategories && card.categories[0].categoryId !== categoryId : true;
          if (card.title && shouldShow && card.isVisibleInNavigation) {
            let image = "";

            if (meta.imageContentId) {
              image = `<div class="card__image_container"><img src="/images/transparent.png" id="card__${cardGuid}" class="card__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;

              getImageByContentId(meta.imageContentId, (img) => {
                const cardImage = document.getElementById(`card__${cardGuid}`);
                if (cardImage) {
                  cardImage.setAttribute("data-src", img.url);
                  cardImage.setAttribute("src", "/images/transparent.png");
                  cardImage.setAttribute("alt", "");
                  cardImage.setAttribute("data-imagehotspot", `${img.imageHotspotX},${img.imageHotspotY}`);
                  setResponsiveImage(cardImage);
                }
              });

              // getImageByContentId(meta.imageContentId, (img) => {
              //   $(`#card__${cardGuid}`).attr({
              //     "data-src": img.url,
              //     src: "/images/transparent.png",
              //     alt: "",
              //     "data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
              //   });
              //   setResponsiveImage($(`#card__${cardGuid}`));
              // });
            }

            let link = `${isTransportPage ? "" : "/artikkel"}/${card.nameInUrl !== "" ? card.nameInUrl : card.contentId}`;
            let dynLink = "";
            if (meta.currentDynamiskMalContent) {
              dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res;
            }

            if (dynLink) {
              link = dynLink;
            }

            let cardSortOrder = card.published ? card.published : card.modified;

            switch (sortOrder) {
              case "sortByDate":
                cardSortOrder = card.published ? card.published : card.modified;
                sortAsc = -1;
                break;
              case "sortByTitle":
                cardSortOrder = card.title;
                sortAsc = 1;
                break;
            }
            cards.push({
              item: carditem({
                link,
                image,
                title: card.title,
                intro: truncateWithElipsis(card.intro, 170),
                tag: card?.tags[0]?.title,
                color: moduleCardColor,
              }),
              order: cardSortOrder,
            });
          }
        }
      }

      let sortedCards = cards.sort((a, b) => {
        if (a.order > b.order) return 1 * sortAsc;
        if (a.order < b.order) return -1 * sortAsc;
        return 0;
      });

      sortedCards = sortedCards.slice(0, maxItems);

      const cardsContainer = document.getElementById(`cards_${moduleGuid}`);
      if (sortedCards.length < 1) {
        cardsContainer.innerHTML = "";
      } else {
        const joinedCards = sortedCards.map((e) => e.item).join("");
        cardsContainer.innerHTML = joinedCards;
        if (cards.length < data.length) {
          // Handle case where there are more cards than displayed
        }
      }
    });
  }

  return cardslist({
    id: moduleGuid,
    title: moduleTitle !== undefined ? moduleTitle : "",
    moretitle: language("CARDS_SEEALL") !== "CARDS_SEEALL" ? language("CARDS_SEEALL") : moreText !== "" ? moreText : "Se mere...",
    morelink: moreLink !== "" ? moreLink : `/nav/${category}`,
    cardDesign,
  });
};
